<div class="drop-padding propWrapper">
  <app-property-multi-selector
    *ngFor="let property of allProperties"
    [propertyData]="property"
    [clearEvent]="clearEvent"
    (AddEvent)="onAddProperty($event)"
    (RemoveEvent)="onRemoveProperty($event)"
  ></app-property-multi-selector>
</div>
